<template>
    <div class="authenticate">
        <p class="title" :style="haveAuthen?'color:#999':'color:#222'">实名认证<img src="../../src/assets/correcting-img/authen-suc.png" alt="" v-if="haveAuthen"></p>
        <div class="form-box">
            <el-form :model="checkForm" :rules="rules" ref="checkForm" label-width="100px" class="check-form">
                <el-form-item label="身份证号:" prop="card">
                    <el-input v-model="checkForm.card" :disabled="haveAuthen" placeholder="请输入身份证号"></el-input>
                </el-form-item>
                <el-form-item label="姓名:" prop="name">
                    <el-input v-model="checkForm.name" :disabled="haveAuthen" placeholder="请输入真实姓名"></el-input>
                </el-form-item>
                <el-form-item label="联系方式:" prop="phone">
                    <el-input v-model="checkForm.phone" :disabled="haveAuthen" placeholder="请输入手机号"></el-input>
                </el-form-item>
                <div style="text-align:center;width:120px;height:40px;margin-left:270px;margin-top:80px;" class="submit-btn-wrap">
                    <el-button type="primary" @click="submitForm('checkForm')" :loading="btnLoading" style="height:40px;line-height:40px;font-size:14px;" v-if="!haveAuthen">提交审核</el-button>
                    <div class="auth-done" v-if="haveAuthen">审核通过</div>
                </div>
            </el-form>
        </div>
        <p class="authenticate-tig" v-if="!haveAuthen">提示：实名验证后才可上传剧本。</p>
    </div>
</template>

<script>
import Axios from '@/api/Axios'
import {SetCookie,GetCookie} from '@/api/cookie'
export default {
    name: 'Authenticate',
    props:['realAuthenInfo'],
    data(){
        var validatePass1 = (rule,value,callback) =>{
            if (value === '') {
                callback(new Error('身份证不能为空'));
            } else if(value.length!==18){
                callback(new Error('请输入正确的身份证号'));
            } else {
                callback();
            }
        };

        var validatePass2 = (rule,value,callback) =>{
            if(value.length<2){
                callback(new Error('请输入正确姓名'));
            }
            if(!/^[\u4e00-\u9fa5]+$/gi.test(value)){
                callback(new Error('请输入正确姓名'));
            }
            if (value === '') {
                callback(new Error('姓名不能为空'));
            } else {
                callback();
            }
        };

        var validatePass3 = (rule,value,callback) =>{
            var reg = /^1[0-9]{10}$/
            if (value === '') {
                callback(new Error('手机号码不能为空'));
            } else if (!reg.test(value)) {
                callback(new Error('请输入正确的手机号'));
            }else {
                callback();
            }
        };
        
        return {
            checkForm: {
                name: '',
                card:'',
                phone:''
            },
            rules: {
                name:[
                    {required: true,validator:validatePass2,trigger:'blur'}
                ],
                card:[
                    {required: true,validator:validatePass1,trigger:'blur'}
                ],
                phone: [
                    {required: true,validator: validatePass3, trigger: 'blur' }
                ]
            },
            haveAuthen:false,             //判断是否已认证控制input输入框disable状态
            btnLoading:false              //控制提交审核按钮可点击状态
        };
    },
    created(){
        if(location.href.indexOf('usercenter')){
            if(GetCookie('real_auth')==1){
                this.haveAuthen=true
                Axios.get('user/info','').then(
                    response=>{
                        if(response.data.code==200&&response.data.status=="success"){
                            this.checkForm=response.data.data.real_name_arr
                        }
                    },
                    error=>{
                        console.log(error)
                    }
                )
            }
        }
    },
    methods:{
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.btnLoading=true
                    Axios.post('card/auth',this.checkForm).then(
                        response=>{
                            this.btnLoading=false
                            if(response.data.status==='error'&&response.data.code===200){
                                this.$message.error({
                                    message:response.data.message,
                                    type: 'error',
                                    center:true,
                                    offset:100,
                                    duration:900
                                });
                            }else if(response.data.status==='success'&&response.data.code===200){
                                if(location.href.indexOf('usercenter')){
                                    this.haveAuthen=true
                                    this.checkForm.name=response.data.data.name
                                    this.checkForm.card=response.data.data.card
                                    this.checkForm.phone=response.data.data.phone
                                    SetCookie('real_auth',response.data.data.check)
                                    return false
                                }
                                this.$message.success({
                                    message: '验证通过',
                                    type: 'success',
                                    center:true,
                                    offset:100,
                                    duration:900
                                });
                                SetCookie('real_auth',response.data.data.check)
                                this.$emit('authenticate',true)
                            }
                        },
                        error=>{
                            this.btnLoading=false
                            console.log(error)
                        }
                    )
                }
            })
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.authenticate{
    width:960px;
    margin:0 auto;
    position:relative;
    background:#fff;
    padding-bottom:80px;
    .el-input.is-disabled .el-input__inner{
        background-color:#fff !important;
        border:none !important;
        font-size:18px !important;
        color:#222 !important;
    }
    .title{
        text-align:left;
        margin-bottom:66px;
        font-size:20px;
        padding:50px 42px 35px 42px;
        font-weight:bold;
        color:#222;
        border-bottom:1px solid #e6e6e6;
        img{
            float:right;
        }
    }
    .form-box{
        width:670px;
        margin:0 auto;
    }
    .el-form-item{
        margin-bottom:30px;
    }
    .auth-done{
        width:114px;
        height:46px;
        line-height:46px;
        background:#22AC38;
        text-align:center;
        color:#fff;
        border-radius:25px;
    }
    .el-form-item__label{
        font-size:16px !important;
        color:#999 !important;
        transform:translateY(6px);
    }
    input:focus{
        outline:none;
        border:1px solid #000;
    }
    .el-button--primary{
        background:#BF0000 !important;
        width:114px;
        height:46px;
        line-height:46px;
        border:none;
        padding:0;
        border-radius:24px;
    }
    .el-button--primary:hover{
        background:#DF8080 !important;
        color:#fff !important;
        border:none !important;
    }
    .el-button--default{
        background:#fff !important;
        color:#BF0000 !important;
        border:1px solid #BF0000 !important;
        width:120px;
        height:30px;
        line-height:30px;
        padding:0;
    }
    .el-button--default:hover{
        background:#fff !important;
        font-weight:bold !important;
        color:#BF0000 !important;
        border:1px solid #BF0000 !important;
    }
    .authenticate-tig{
        text-align:center;
        font-size:14px;
        color:#999;
        margin-top:20px;
    }
    .el-loading-mask{
        border-radius:4px;
    }
    .el-input__inner{
        border-radius:24px;
        height:50px !important;
        font-size:18px !important;
        padding-left:20px;
    }
    .el-input__inner:focus{
        border:1px solid #000 !important;
    }
}
</style>
